import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IPostVideoCategoryRequest } from '../models/requestModels'
import { IVideoCategory } from '../models/responseModels'

export class PutVideoCategoryApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/video-category/put',
      requesterInfo,
    })
  }

  public async putVideoCategory(request: IPostVideoCategoryRequest): Promise<IVideoCategory> {
    return await this.putAsync<IVideoCategory>(undefined, request)
  }
}
